import { get } from "svelte/store";
import { accessTokenStore } from "../../../stores";

export const getKeyVal = async (key: string, client_id: string): Promise<{
  items: {
    key: string;
    val: string;
  }[];
}> => {
  const res = await fetch(`https://api.staging.credenza3.com/keyval/key/${key}?client_id=${client_id}`, {
    headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${get(accessTokenStore)}`,
      },
      method: "GET",
    }
  )

  if (!res.ok) throw new Error("Failed to get key value");
  return await res.json();
}

export const parseUpcCodeAndGetValue = async (upcCode: string, clientId: string): Promise<[string, string]> => {
  const res = await getKeyVal(upcCode, clientId);
  const value =res.items[0].val;

  const scanType = JSON.parse(value).scanType

  return [scanType, value]
}